import type { components } from '../../api/generated/schema';
import type { Collection, CollectionChanges, NewCollection } from '../../domain/collections';
import { toPersonRef } from '../mapping';

type S = components['schemas'];

export function toCollection(c: S['Collection']): Collection {
  return {
    id: c.id,
    name: c.name,
    description: c.description,
    visibility: c.visibility,
    commentsEnabled: c.comments_enabled,
    isDefault: c.is_default,
    owner: toPersonRef(c.owner),
    myRelation: c.my_relation,
    listingCount: c.listing_count,
    isMuted: c.is_muted,
    createdAt: c.created_at,
    updatedAt: c.updated_at,
  };
}

export function toNewCollection(input: NewCollection): S['CollectionCreateRequest'] {
  return {
    name: input.name,
    description: input.description,
    visibility: input.visibility,
    comments_enabled: input.commentsEnabled,
  };
}

export function toCollectionChanges(
  changes: CollectionChanges,
): S['PatchedCollectionUpdateRequest'] {
  const body: S['PatchedCollectionUpdateRequest'] = {};
  if (changes.name !== undefined) body.name = changes.name;
  if (changes.description !== undefined) body.description = changes.description;
  if (changes.commentsEnabled !== undefined) body.comments_enabled = changes.commentsEnabled;
  return body;
}
